module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.dca9d913.svg";